"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _core = require("@clayui/core");
var _react = _interopRequireWildcard(require("react"));
var _DropDownContext = require("./DropDownContext");
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) { if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } } return n.default = e, t && t.set(e, n), n; }
/**
 * SPDX-FileCopyrightText: © 2019 Liferay, Inc. <https://liferay.com>
 * SPDX-License-Identifier: BSD-3-Clause
 */

var Collection = _core.__NOT_PUBLIC_COLLECTION.Collection;
var counter = 0;
function Group(_ref) {
  var children = _ref.children,
    header = _ref.header,
    items = _ref.items,
    _ref$role = _ref.role,
    role = _ref$role === void 0 ? 'group' : _ref$role;
  var ariaLabel = (0, _react.useMemo)(function () {
    counter++;
    return "clay-dropdown-menu-group-".concat(counter);
  }, []);
  var _useContext = (0, _react.useContext)(_DropDownContext.DropDownContext),
    search = _useContext.search;
  var filterFn = (0, _react.useCallback)(function (value) {
    return value.match(new RegExp(search, 'i')) !== null;
  }, [search]);
  return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, header && /*#__PURE__*/_react.default.createElement("li", {
    "aria-hidden": "true",
    className: "dropdown-subheader",
    id: ariaLabel,
    role: "presentation"
  }, header), /*#__PURE__*/_react.default.createElement("li", {
    role: "presentation"
  }, /*#__PURE__*/_react.default.createElement("ul", {
    "aria-labelledby": ariaLabel,
    className: "list-unstyled",
    role: role
  }, /*#__PURE__*/_react.default.createElement(Collection, {
    filter: filterFn,
    filterKey: "textValue",
    items: items,
    passthroughKey: false
  }, children))));
}
Group.displayName = 'Group';
var _default = exports.default = Group;